module.exports = __webpack_public_path__ + "static/salamander-dc74edd89657eb734dd93ad2ce5c0d10.jpeg";